import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=b46344b2&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=js&"
export * from "./SingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=b46344b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46344b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VForm,VSelect})
